import type { JSX, Signal } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import MobileMenuSI from '~/icons/mobileMenuSI';
import type { COLOR } from '~/types/AppData/Theme/ColorInterface';
import { getCSSColorFill } from '~/utilities/getCSS';

type MobileIconType = {
  mobileActive: Signal<boolean>;
  fill: COLOR;
};

const iconColor = cva('', {
  variants: {
    fill: getCSSColorFill(),
  },
});
export default component$(
  ({ mobileActive, fill }: MobileIconType): JSX.Element => {
    return (
      <button
        class='block lg:hidden w-6 h-6 relative cursor-pointer'
        onClick$={() => {
          mobileActive.value = !mobileActive.value;
        }}
        aria-label='More Menu Items'
      >
        <MobileMenuSI
          cssClasses={iconColor({ fill })}
          active={mobileActive.value}
        />
      </button>
    );
  }
);
